import * as angular from "angular";
import {IController} from "angular";
import {PlanningCommonService} from "../../services/planning-coomon-service.service";
import * as _ from "lodash";

export class PlanningJobsTableRowCtrl implements IController {
  job: any;
  depotsMap: any;
  isSelected: any;
  isDraft: any;
  onToggle: Function;
  onRemove: Function;
  onPriorityChange: Function;
  onView: Function;
  onAddToDraft: Function;
  onRemoveFromDraft: Function;

  private configZoneId: any;
  private routeColor: any;
  private resource: any;
  public labels: string[];


  /* @ngInject */
  constructor(private splitService) {
  }

  $onInit() {
    this.configZoneId = this.splitService.getTimeZone();
    this.labels = _.uniq(_.compact(_.flatMap(this.job.packages, 'labels')));
  }
}

angular
  .module('bringoz.admin.planning')
  .component('planningJobsTableRow', {
    bindings: {
      job: '<',
      depotsMap: '<',
      isSelected: '<',
      isDraft: '<',
      onToggle: '&',
      onRemove: '&',
      onPriorityChange: '&',
      onView: '&',
      onAddToDraft: '&',
      onRemoveFromDraft: '&'
    },
    template: require('./planning-jobs-table-row.html').default,
    controller: PlanningJobsTableRowCtrl
  });
